export const colorVariant = {
  Grey50: 'Grey50',
  greys_500_grey: 'greys/500_grey',
  blue_main: 'blue_main',
  blue_light: 'blue_light',
  greys_50_grey: 'greys/50_grey',
  DarkBlue: 'Dark Blue',
  disabledPrimary900: 'disabled/primary/900',
};
